const geofence = {
  name: "电子围栏",
  geofenceName: "电子围栏名称",
  in: "驶入",
  out: "驶出",
  shape: {
    name: "电子围栏类型",
    circle: "圆形",
    rectangle: "矩形",
    polygon: "多边形",
    warning: {
      circle: "请设置圆心和半径",
      rectangle: "请绘制矩形",
      polygon: "请绘制至少3个点"
    }
  },
  radius: "半径(米)",
  centerPosition: "圆心坐标",
  mapPoint: "地图选点",
  style: {
    queryLabelWidth: "90px",
    formLabelWidth: "90px",
    formLabelWidth2: "90px"
  }
} 
export default geofence